import React from "react";

function FullScreenVideo({ mp4, image, format }) {
  return (
    <div className="h-full w-full absolute">
      <video autoPlay loop muted playsInline poster={image}>
        <source src={mp4} type={`video/${format}`} />
        Your browser does not support the video tag.
      </video>
    </div>
  );
}

export default FullScreenVideo;
